import { render, staticRenderFns } from "./StepWrap.vue?vue&type=template&id=37e4aa5b&scoped=true&"
import script from "./StepWrap.vue?vue&type=script&lang=js&"
export * from "./StepWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4aa5b",
  null
  
)

export default component.exports